<!--
	AuthSearchPanel.svelte

    Receives the masterSearch store object as a prop

    Contains the following components:

        <AuthSearchBar>         // new 9/20
        <SearchRadiusPicker>
        <Button>
        <SearchChips>
        <TreeViewers>

    Each of these gets passed the same masterSearch store object

-->


<script>
    import { onMount } from 'svelte';
	import { isShowingSearchOptions } from '../../stores/ScreenSettingsStore';

    // TCARE components
	import AuthSearchBar from './AuthSearchBar.svelte';
	import SearchRadiusPicker from './SearchRadiusPicker.svelte';
	import SearchChips from './SearchChips.svelte';
	import TreeViewers from '../tree-viewer/TreeViewers.svelte';
    

    // SMUI components
    import Button from '@smui/button';
    import Checkbox from '@smui/checkbox';

    // 5/11 - NEW ARCHITECTURE
    export let store;                                               // Search or Service object

    onMount(() => {
    })

    const _onOptionsButtonClick = () => {
        $isShowingSearchOptions = !$isShowingSearchOptions;
    }

</script>


<style>

    .search-row {
        height: 50px;       /* avoid glitch when LocationBar opens */
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    :global(.auth-search-panel .mdc-button) {
        width: 200px;
        color: var(--tcare-primary);
        border-radius: 18px;
        overflow: hidden;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="auth-search-panel">
    <div class="search-row">
        <div class="flex-row jc-start">
            <AuthSearchBar {store} />
            <div class="spacer-w-15"></div>
            <SearchRadiusPicker {store} />
        </div>

        <Button color="primary" on:click={_onOptionsButtonClick} variant="outlined">
            {#if $isShowingSearchOptions}
                Hide Options
            {:else}
                More Options
            {/if}
        </Button>    
    </div>

    <div class="spacer-h-20"></div>
    <SearchChips {store} />

    <!-- show the expanded area with the trees -->
    {#if $isShowingSearchOptions}
        <div class="spacer-h-15"></div>
        <div class="flex-row jc-start">
            <Checkbox bind:checked={$store.virtualOnly} />
            Include only virtual services
        </div>
        <TreeViewers {store} />
    {/if}
</div>
